<template lang="pug">
  v-dialog(v-model="showWarningDialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent)
    v-card.d-flex.flex-column(flat )
        v-card-title.headline {{ $t('businessPage.deleteTimeBlockLabel') }}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
            v-row(v-if="$vuetify.breakpoint.mdAndUp")
              v-col(cols="12")
                span {{ $t('businessPage.deleteTimeBlockText') }}
            v-row.text-center(v-else align="center" )
              v-col(cols="12" align="center")
                span {{ $t('businessPage.deleteTimeBlockText') }}
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="onCancelButtonClick" :disabled="inProgress") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn(color="primary" @click="onSubmitButtonClick" :loading="inProgress") {{ $t('settingsPage.deleteButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import BusinessTimeBlockCollection from "@/model/business/BusinessTimeBlockCollection";

@Component({})

export default class WarningDeleteTimeBlockDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly showWarningDialog!: boolean
  @Prop({type: Object as () => BusinessTimeBlockCollection}) selectedTimeBlock!: BusinessTimeBlockCollection

  private inProgress: boolean = false

  onSubmitButtonClick (): void {
    this.inProgress = true
    this.$emit('yes')
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }
}

</script>

<style lang="stylus" scoped>

</style>
